import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import 'react';
import 'lodash-es';
import '@bucketplace/ui';
import { useEditor } from '../../hooks/useEditor.js';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../contexts/internal/StickyContext.js';
import '../../contexts/internal/EditorContext.js';
import 'qs';
import 'query-string';
import '@bucketplace/bucket-log';
import { HeaderButton } from './HeaderButton.js';

function HeaderTogglePreview() {
  var _useEditor = useEditor(),
    state = _useEditor.state,
    setState = _useEditor.setState;
  return jsx(HeaderButton, {
    isActive: state.displayMode === 'view',
    onClick: function onClick() {
      return setState(function (state) {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          displayMode: state.displayMode === 'view' ? 'edit' : 'view'
        });
      });
    }
  }, "\uBBF8\uB9AC\uBCF4\uAE30");
}

export { HeaderTogglePreview };
//# sourceMappingURL=TogglePreview.js.map
